import React from 'react';

import { Tabs } from './components/Tabs';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

import { useGenderTabs } from './hooks/useGenderTabs';
import { useHighlightingErrorGender } from './hooks/useHighlightingErrorGender';

export const GenderTabs: React.FC = () => {
    const genderTabs = useGenderTabs();

    useHighlightingErrorGender();

    return (
        <Tabs
            name={VALIDATION_FIELDS.gender}
            options={genderTabs}
        />
    );
};
